import React from 'react';
import Tool, {
  type IToolAvailableInput,
  type ToolButtonComponent,
} from './Tool';
import ToolButton from '../toolbars/ToolButton';
import { ApplicationView } from '@aha-app/mvc';
import addLabelIcon from '../assets/icons/addLabel.svg';
import { svgToIcon } from '../utils/svg';
import { isConnector } from '../objects/guards';

const AddLabelButton: ToolButtonComponent = ApplicationView(
  ({ selection, tool }) => {
    return (
      <ToolButton
        onClick={() => selection?.createLabelWithCalculatedOffset?.()}
        tool={tool}
      >
        {svgToIcon(addLabelIcon)}
      </ToolButton>
    );
  }
);

class ToolAddLabel extends Tool {
  static toolName = 'Label';

  static available({ selection }: IToolAvailableInput) {
    const objects = selection?.getObjects();
    return objects?.length === 1 && isConnector(objects[0]);
  }

  static buttonComponent() {
    return AddLabelButton;
  }
}

export default ToolAddLabel;
